import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeployInstanceFormComponent } from './deploy-instance-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { PipesModule } from 'src/app/pipes/pipes.module';
// import { MatTimepickerModule } from '@dhutaryan/ngx-mat-timepicker';


@NgModule({
  declarations: [
    DeployInstanceFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    ErrorModule,
    PipesModule,

    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatChipsModule,
    // MatTimepickerModule
  ],
  exports: [
    DeployInstanceFormComponent
  ]
})
export class DeployInstanceFormModule { }

